import { useState, memo, useRef } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import { Recaptchahandler } from '@/api/endpoints'
import ReCAPTCHA from 'react-google-recaptcha';
import AuthWrapper from '../components/authWrapper';
import Field from '@/component/formFields/InputField/Field';

const recaptchaSiteKey = import.meta.env.VITE_RECAPTCHA_SITEKEY

const ForgetPassForm = ({ onSubmit }) => {

    const [email, setEmail] = useState('')
    const [loading, setLoading] = useState(false)
    const { t } = useTranslation()
    const captchaRef = useRef(null);
    const [isHuman, setIsHuman] = useState(false);

    const recaptchahandler = () => {
        const RecaptchaData = {
            token: captchaRef.current.getValue(),
        }

        Recaptchahandler(RecaptchaData).then(res => {
            setIsHuman(res.data)
        })
    }


    return (

        <AuthWrapper>
            <div className='inputsContainer'>
                <div className='input-container'>
                    <Field value={email} setValue={setEmail} placeholder={t("Email")} label={t("Email")} type="text" name="email" />
                </div>
            </div>
            <div className='recaptcha-container'>
                <ReCAPTCHA className='recaptcha' sitekey={recaptchaSiteKey} ref={captchaRef} onChange={recaptchahandler} />
            </div>
            <button className="login-btn" onClick={e => onSubmit(e, { email, setLoading })} disabled={loading || !isHuman}>
                <span className={loading ? "spinner-border spinner-border-sm" : ""} role="status" aria-hidden="true"></span>
                {t("Send Code")}
            </button>
            <div className='donot-have-account-container'>
                {t("backTo")} <Link to='/'>{t("login")}</Link>
            </div>
        </AuthWrapper>

    );
}

export default memo(ForgetPassForm);

